import React, {createRef, RefObject} from "react"
import {findDOMNode} from "react-dom"

type Props = {
    className?  : string

    type?       : 'left' | 'right' | 'both' // min/max for left or right container
    min?        : string | number           // string or number for 'left'/'right' type
    max?        : string | number           // string or number for 'left'/'right' type
    minLeft?    : string | number           // string or number for 'both' type
    minRight?   : string | number           // string or number for 'both' type

    eventPrefix?: string                    // bus event prefix

    data?       : any                       // pass any data to be added to bus event

    children?   : any
}

const debug = false
// const debug = "VerticalResizeSeparator"

export default class VerticalResizeSeparator extends React.Component<Props> {

    private mouseDownX              : number = 0
    private xDelta                  : number = 0
    private fullWidth               : number = 0
    private leftPartWidth           : number = 0
    private minLeft                 : number = 0
    private maxLeft                 : number = 0

    private debounceUpdateBoundaries: any

    private hoverLineNode           : any
    private thisNode                : any

    private hoverLineRef            : RefObject<any> = createRef()

    static defaultProps = {
        type        : 'both',
        min         : 300,
        max         : '60%',
        minLeft     : 440,
        minRight    : 300,
        eventPrefix : "task-view"
    }

    constructor(props: Props) {
        super(props)

        this.debounceUpdateBoundaries = _.debounce(()=>{this._updateBoundaries()}, 100);
    }

    componentDidMount() {
        this.hoverLineNode = findDOMNode(this.hoverLineRef.current)
        this.thisNode = findDOMNode(this)

        this.debounceUpdateBoundaries()

        gd.layout.on('change:widthMain', this.update, this)
    }

    componentDidUpdate() {
        this.debounceUpdateBoundaries()
    }

    componentWillUnmount() {
        this.debounceUpdateBoundaries.cancel()
        gd.layout.off('change:widthMain', this.update, this)
    }

    update = () => {this.debounceUpdateBoundaries()}

    _updateBoundaries = () => {
        this.fullWidth = this.thisNode.parentNode.clientWidth;
        this.leftPartWidth = this.thisNode.offsetLeft;

        debug && console.log(debug, '_updateBoundaries', this.props.min, this.props.max, this.props.minLeft, this.props.minRight)

        switch(this.props.type){
            case 'left':
                if (!_.isNil(this.props.min))   this.minLeft = - Math.abs(this.leftPartWidth - this._calculateBoundary(this.props.min, this.fullWidth))
                if (!_.isNil(this.props.max))   this.maxLeft =   Math.abs(this.leftPartWidth - this._calculateBoundary(this.props.max, this.fullWidth))
                break

            case 'right':
                if (!_.isNil(this.props.max))   this.minLeft = - Math.abs(this.fullWidth - this.leftPartWidth - this._calculateBoundary(this.props.max, this.fullWidth))
                if (!_.isNil(this.props.min))   this.maxLeft =   Math.abs(this.fullWidth - this.leftPartWidth - this._calculateBoundary(this.props.min, this.fullWidth))
                break

            case 'both':
                if (!_.isNil(this.props.minLeft))   this.minLeft = - Math.abs(this.leftPartWidth - this._calculateBoundary(this.props.minLeft, this.fullWidth))
                if (!_.isNil(this.props.minRight))  this.maxLeft =   Math.abs(this.fullWidth - this.leftPartWidth - this._calculateBoundary(this.props.minRight, this.fullWidth))
                break
        }
    }

    _calculateBoundary = (value: string | number, fullWidth: number) => {
        let res;
        if (typeof value === 'string')  res = fullWidth * parseInt(value) /100;
        else                            res = value;
        return res;
    }

    _getNormalizedLeft = () => {
        let res = this.xDelta;
        if (this.xDelta < this.minLeft) res = this.minLeft;
        if (this.xDelta > this.maxLeft) res = this.maxLeft;
        return res;
    }

    _calculateValuesForEvent = () => {
        const left = this._getNormalizedLeft();
        const newLeftPartWidth = this.leftPartWidth + left;
        const newLeftPartPercentWidth = (newLeftPartWidth / this.fullWidth) * 100;

        return {value:newLeftPartWidth, percentValue:newLeftPartPercentWidth}
    }

    onMouseDown = (e:any) => {
        e.stopPropagation()
        e.preventDefault()

        this.mouseDownX = e.clientX
        this.xDelta     = 0
        gd.utils.Dom.addClass(this.hoverLineNode,'is-visible')

        document.addEventListener("mousemove", this.handleMouseMove, {capture: true})
        document.addEventListener("mouseup", this.handleMouseUp, {capture: true})

        gd.bus.triggerEvent(this.props.eventPrefix+':resizing', _.assign({isResizing: true}, this.props.data))
    }

    handleMouseMove = (e:any) => {
        this.xDelta = e.clientX - this.mouseDownX
        this.hoverLineNode.style.setProperty("left", this._getNormalizedLeft() + "px")
    }

    handleMouseUp = (e:any) => {
        e.stopPropagation()
        const {value, percentValue} = this._calculateValuesForEvent()

        gd.bus.triggerEvent(this.props.eventPrefix+':vertical-separator-resize-left', value, percentValue, this.props.data)
        gd.bus.triggerEvent(this.props.eventPrefix+':vertical-separator-resize-right', this.fullWidth - value, 100 - percentValue, this.props.data)

        gd.utils.Dom.removeClass(this.hoverLineNode,'is-visible')
        this.hoverLineNode.style.setProperty("left", 0 + "px")

        document.removeEventListener("mousemove", this.handleMouseMove, {capture: true})
        document.removeEventListener("mouseup", this.handleMouseUp, {capture: true})

        // setTimeout(this._updateBoundaries,0)
        this.debounceUpdateBoundaries()

        gd.bus.triggerEvent(this.props.eventPrefix+':resizing', _.assign({isResizing: false}, this.props.data))
    }

    // *children used in my work

    render() {
        const classes = Classes("gd-vertical-resize-separator", this.props.className)

        return (
            <div className      = {classes}
                 onClick        = {e=>e.stopPropagation()}
                 onMouseDown    = {this.onMouseDown}>
                <div ref={this.hoverLineRef} className="hover-line">
                    <div className="hover-line-background"/>
                    <div className="hover-line-cursor"/>
                </div>
                {this.props.children}
            </div>
        )
    }
}